import { useAPI } from '@/composables';

// Response types
export interface AiChatResponse {
  data: {
    message: string;
    credits_remaining: number;
  };
  status: boolean;
  message?: string;
}

export interface CreditEstimationResponse {
  data: {
    estimated_credits: number;
    message: string;
    remaining_credits: number;
    has_enough_credits?: boolean;
  };
  status: boolean;
  message?: string;
}
export interface CreditPackage {
  id: number;
  name: string;
  description: string;
  price: number;
  price_current_formatted: string;
  handler_class: string;
  is_active: boolean;
  metadata: {
    credit_amount: number;
  };
}

export interface CreditPackagesResponse {
  data: CreditPackage[];
  status: boolean;
  message?: string;
}

/**
 * Send a message to the AI chat service
 *
 * @param message The user's message to send to the AI
 * @returns Promise with the AI response
 */
export const sendChatMessage = (message: string) => {
  return useAPI<AiChatResponse>('/ai/chat', {
    method: 'POST',
    body: { message }
  });
};

/**
 * Get the estimated credits required for a message
 *
 * @param message The message to estimate credit usage for
 * @returns Promise with the estimated credits
 */
export const estimateCredits = (message: string) => {
  return useAPI<CreditEstimationResponse>('/ai/estimate', {
    method: 'POST',
    body: { message }
  });
};

/**
 * Get available AI credit packages
 *
 * @returns Promise with available credit packages
 */
export const getCreditPackages = () => {
  return useAPI<CreditPackagesResponse>('/ai/credit-packages');
};

export const getScanResults = (scanId: string) => {
  return useAPI(`/plugin-scan/${scanId}`);
};
